<template>
  <div class="header">
    <div class="header-tool justify-between">
      <div class="margin-left-20">
        <!-- <img :src="logo" height="24" />
        <div class="font-size-12">
          股票代码：301299
        </div> -->
      </div>
      <div class="text-nowrap"></div>
    </div>
    <div class="header-text">{{title}}</div>
    <div class="header-tool">
      {{time}}
      <!-- <div class="text-nowrap">卓创资讯数智中心制作</div> -->
    </div>
    
  </div>
</template>

<script>
import logo from '@/assets/images/logo.png'
export default {
  name: 'Header',
  components: {

  },
  props:{
    title:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      logo,
      time:'',
    }
  },
  methods:{
    getTime(){
      let date = new Date();
          // date_text=date.toLocaleDateString(),
          // hours = date.getHours(),
          // one = parseInt(hours / 10),
          // two = parseInt(hours % 10),
          // minutes = date.getMinutes(),
          // three = parseInt(minutes / 10),
          // four = parseInt(minutes % 10),
          // second = date.getSeconds(),
          // five = parseInt(second / 10),
          // six = parseInt(second % 10);
          this.time=date.format('yyyy年M月d日 hh:mm:ss')
        },
    
    logout(){
      //弹窗提示
      this.$confirm('您要退出登录吗?', '退出登录', {
        customClass:"custom-msgbox",
        confirmButtonText: '继续退出',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        this.$instance.get('/logout',{
            params: {
              ...this.$store.state.basicParams,
            },
        })
        .then(res=>{
          if(res.data.code==0){
            try{
              localStorage.removeItem("loginRes");
            }catch{
              //
            }
            this.$router.replace({
              path: '/login',
            })
          }
        })
        
      })
      .catch(() => {});
    },

  },
  created(){
    this.getTime()
    setInterval(this.getTime,1000);
  },
  mounted(){

  },
  watch: {
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
  .header{
      height: 76px;
      flex: 0 0 76px;
      position: relative;
      overflow: hidden;
      display: flex;
      width: 100%;
      justify-content: center;
      position: relative;
      z-index: 2;
  }
  .header::before{
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
          background:url('~@/assets/images/header_bg.png') center bottom no-repeat;
      z-index: -1;
  }
  .header-text{
      flex: 0 0 1140px;
      font-size: 36px;
      font-weight: bold;
      height: 76px;
      line-height: 72px;
      text-align: center;
      letter-spacing:10px;
      color: #fff;
      @include themeify{
          text-shadow: 0px 0px 25px themed('textColorSub');
      };
  }
  .header-tool{
      flex: 1;
      display: flex;
      margin-top:30px;
      @include themeify{
          color: themed('textColor');
      };
  }

  .theme-btn{
      @include themeify{
          border-color:themed('borderColor');
      };
      border-width: 1px;
      border-left-style: solid;
      border-right-style: solid;
      padding: 0 10px;
  }
</style>
